import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../Services/order.service';
import {Order} from '../../../back-office/Models/Order';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-success-order',
  templateUrl: './success-order.component.html',
  styleUrls: ['./success-order.component.scss']
})
export class SuccessOrderComponent implements OnInit {
  public orderId: number;
  public order: Order = new Order();
  public email;
  public baseUrl = environment.apiUrl;
  public pdfLink: string;
  @ViewChild('pdfModal', {static: false}) pdfModal = null;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private route: ActivatedRoute, private orderService: OrderService, private helper: Helper, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        this.orderService.getOrderSuccess(this.orderId).subscribe((resp) => {
          this.order = resp;
        });
      }
    });
  }

  downloadOrderPdf(id) {
    this.orderService.getPdf(id).subscribe((resp) => {
      // const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      // el.setAttribute('href', resp.url);
      // el.setAttribute('download', resp.filename);
      // el.click();
    });
  }

  sendOrderEmail() {
    this.orderService.sendPdf(this.orderId, this.email).subscribe((resp) => {
      this.helper.popMessageDialog(
        this.translateService.instant('global.success_message.title'),
        this.translateService.instant('admin.order.send_email_success_message'),
        'success',
        false);
    });
  }
}
